import { InputGroup } from "@blueprintjs/core"
import { Autocomplete } from "@react-google-maps/api"
import React, { useRef, useState } from "react"
import formatAddress from "utils/googleMaps"
import CustomButton from "../../Atoms/CustomButton"
const AutoComplete = ({ onChange }) => {
  const [query, setQuery] = useState("")
  const autoCompleteRef = useRef()

  return (
    <Autocomplete
      onLoad={autocomplete => {
        autoCompleteRef.current = autocomplete
      }}
      onPlaceChanged={() => {
        const place =
          autoCompleteRef.current && autoCompleteRef.current.getPlace()
        onChange(
          formatAddress(place?.address_components),
          place?.geometry?.location?.toJSON?.()
        )
        setQuery("")
      }}
    >
      <InputGroup
        onChange={e => setQuery(e.target.value)}
        value={query}
        leftIcon="search"
        className="vt-map-autocomplete-input"
        rightElement={<CustomButton icon="cross" intent="danger" minimal />}
      />
    </Autocomplete>
  )
}

export default AutoComplete
